export const isSpecialLink = (url: string): boolean =>
  url.startsWith('mailto:') || url.startsWith('tel:');
